<template>
  <KycDesktop
    :ratio="1/4"
    :title="$t('kyc.titles.financial')"
    next-button-theme="primary"
    back-route="/kyc/desktop/identity"
    @next="next"
  >
    <FinancialContent class="mb-8" />
  </KycDesktop>
</template>

<script>
import KycDesktop from '../Desktop.vue';
import FinancialContent from '../FinancialContent.vue';
import BaseTitleGroup from '../../../components/BaseTitleGroup.vue';
import BaseSubtitle from '../../../components/BaseSubtitle.vue';
import BaseSmallTitle from '../../../components/BaseSmallTitle.vue';

export default {
  name: 'FinancialIntroduction',
  components: {
    KycDesktop,
    FinancialContent,
    BaseTitleGroup,
    BaseSubtitle,
    BaseSmallTitle,
  },
  methods: {
    next() {
      this.$router.push('/kyc/desktop/financial');
    },
  },
};
</script>
